import { instance } from '../../config/intercepter';

export const importLogsFn = async (file) => {
  const response = await instance.get(`api/downloadimportlog/${file}`);
  return response.data;
};

export const downloadInvoicesByIdFn = async (id) => {
  const response = await instance.get(`api/invoicesdownload/${id}`);
  return response.data;
};

// rename and check where its getting used
export const downloadLogs1Fn = async () => {
  const response = await instance.get(`api/downloadlogs/create`);
  return response.data;
};

export const downloadReportsFn = async (payload) => {
  const response = await instance.post(`api/reportdata`, payload, {
    headers: {
      'content-type': 'application/json',
      Accept: 'application/pdf',
    },
  });
  return response.data;
};

export const getExtendedReportFn = async (hash) => {
  const response = await instance.get(`api/extendedreports/${hash}`);
  return response.data;
};

export const importTemplteFn = async (field) => {
  const response = await instance.get(`api/localfile/${field}`, {
    headers: {
      'Content-Type': 'blob',
    },
    responseType: 'arraybuffer',
  });
  return response.data;
};

export const getExistingDrivers = async (hash) => {
  const response = await instance.get(`api/exportdrivers`, {
    headers: {
      'Content-Type': 'blob',
    },
    responseType: 'arraybuffer',
  });
  return response.data;
};

export const downloadCSV = async (link) => {
  const response = await instance.get(link, {
    headers: {
      'content-type': 'application/json',
      Accept: 'application/csv',
    },
    responseType: 'arraybuffer',
  });

  try {
    const file = new Blob([response.data], {
      type: 'text/csv;charset=utf-8',
    });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  } catch (e) {
    console.log(e);
  }
  return response.data;
};

export const downloadDocument = async (link = '', id = '', cncode = '') => {
  const api = link ? link : `/api/orders/${cncode}/file/${id}`;
  const response = await instance.get(api, {
    headers: {
      'content-type': 'application/json',
      Accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  });

  let contentType = 'application/pdf';

  if (response.headers['content-type']) {
    contentType = response.headers['content-type'];
  }

  try {
    const file = new Blob([response.data], {
      type: contentType + ';base64',
    });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  } catch (e) {
    console.log(e);
  }
  return response.data;
};
